import '@fontsource/oxanium/500.css';
import '@fontsource/oxanium/700.css';
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/600.css';
import './styles.css';
import { App } from './ui/App';

const root = document.querySelector<HTMLElement>('#ui-root');
if (!root) throw new Error('Missing #ui-root application mount.');

const app = new App(root);
void app.start();
